function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('.animated');
  
  if (animatedElements.length === 0) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = getDelayFromClass(entry.target);
        setTimeout(() => {
          entry.target.classList.add('show');
        }, delay);
      } else {
        entry.target.classList.remove('show');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px'
  });
  
  animatedElements.forEach(element => {
    observer.observe(element);
  });
}

function getDelayFromClass(element) {
  const classList = element.classList;
  for (let className of classList) {
    if (className.startsWith('delay-')) {
      const delayValue = className.replace('delay-', '');
      return parseInt(delayValue) || 0;
    }
  }
  return 0;
}

//document.addEventListener('DOMContentLoaded', initScrollAnimations);
window.addEventListener('load', initScrollAnimations);



  window.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(window.location.search);
    // Si la URL tiene el parámetro 'discount', disparamos la apertura del carrito
    if (window.location.pathname.includes('/discount/') || window.location.search.includes('openCart=')) {
      console.log('JS DISCOUNT TRIGGERED');
      // Este selector varía según la versión de Horizons, 
      // pero usualmente busca el botón del carrito y le hace clic
      const cartButton = document.querySelector('cart-drawer-component button');
      if (cartButton) {
        cartButton.click();
      }
    }
  });